<template>
  <div :class="[{mandatory:isMandatory},'date-control', {dropdowncontrol:isDropdownControlled}]">
    <span :class="[{ displayblock: isDisplayedBlock}, 'form-label' ]">{{ question }}</span>&nbsp;
    <cleave v-model="dateEntered" :options="dateMask" class="question-control" :tabIndex="tab"
            @input="questionAnswered" placeholder="dd/mm/yyyy" :disabled="isDisabled" :raw="false"></cleave>
  </div>
</template>
<script>
export default {
  name: 'DateQuestion',
  props: {
    question: String,
    isDisabled: Boolean,
    isMandatory: Boolean,
    isDisplayedBlock: Boolean,
    isDropdownControlled: Boolean,
    existingValue: String,
    tab: {
      type: Number,
      default: 0,
    },
    dateMask: {
      type: Object,
      default() {
        return {
          date: true,
          dateMax: `${new Date().getFullYear()}-12-31`,
          datePattern: ['d', 'm', 'Y'],
          dateMin: '1900-01-01',
        };
      },
    },
  },
  data() {
    return {
      dateEntered: this.existingValue,
    };
  },
  methods: {
    questionAnswered() {
      this.$emit('question-answered', this.dateEntered);
    },
  },
};
</script>
<style lang="scss">
  div.date-control input.question-control { padding: 0;}
</style>
